<template>
	<div class="popup-controller">
		<component ref="popupView" v-if="popupView" :is="popupView" v-bind="props" v-on:click.native.stop="" @close="close()" />
	</div>
</template>

<script>
	export default {
		data: function () {
			return {
				popupView: null,
				props: null,
				lastAnchor: null
			};
		},
		methods: {
			popup(popupView, props) {
				this.popupView = popupView;
				this.props = props;
				this.lastAnchor = props.anchor;

				return this.$refs.popupView;
			},
			toggle(popupView, props) {
				console.log('toggle');

				if (this.lastAnchor != props.anchor || !this.popupView) {
					this.popup(popupView, props);
				} else {
					this.close();
				}
			},
			close() {
				this.popupView = null;
				this.props = null;
				this.lastAnchor = null;
			},
			getPopupView() {
				console.log(this.$refs);
				return this.$refs.popupView;
			}
		},
		created() {
			var self = this;

			document.addEventListener('click', function (event) {
				self.close();
			});

			window.addEventListener('resize', function (event) {
				self.close();
			});
		},
		destroyed() {

		}
	}
</script>

<style lang="scss" scoped>
	.popup-controller {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		pointer-events: none;
	}
</style>